import { trpc } from '@/lib/trpc';

const useValidateResetPassword = () => {
	const { mutate, isPending, error } =
		trpc.user.validateResetPassword.useMutation();

	return {
		validateResetPassword: mutate,
		validateResetPasswordLoading: isPending,
		validateResetPasswordError: error,
	};
};

export default useValidateResetPassword;
